import Vue from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '../router';
import { getToken, removeToken, refreshToken, login } from '@/utils';

const instance = axios.create({
    baseURL: '/',
    timeout: 20000,
    withCredentials: true
});
instance.interceptors.request.use((request)=>{
    request.headers['Tenantdomain'] = store.state.config.domainName;
    request.headers['Authorization'] = getToken('accessToken');
    request.headers['IdToken'] = getToken('idToken');
    // 在发送请求之前做些什么
    return request;
}, (error) => {
    // 对请求错误做些什么
    console.log(error)
});
instance.interceptors.response.use((response) =>{
    const { data } = response;
    if(data.code && data.code !== '00000') {
        if(data.code === 'G0002') {
            const { origin, pathname } = window.location;
            if(pathname.includes('/room/')) {
                removeToken('actId');
                removeToken('recCode');
                removeToken('pageName');
                removeToken('accessToken');
                const pageName = 'ability-compet';
                window.location.href = origin + '/review/' + pageName + '/activity/list'
            }else{
                refreshToken();
            }
            return Promise.reject();
        }
        if(data.code === 'G0003') {
            const { origin, pathname } = window.location;
            if(pathname.includes('/room/')) {
                removeToken('actId');
                removeToken('recCode');
                removeToken('pageName');
                removeToken('accessToken');
                const pageName = 'ability-compet';
                window.location.href = origin + '/review/' + pageName + '/activity/list'
            }else{
                login();
            }
            return Promise.reject();
        }
        if(data.code === 'C0005') {
            login();
            return Promise.reject();
        }
        if(data.code === 'E0003') {
            router.replace({name: 'noAuth'})
            return Promise.reject();
        }
        new Vue().$message.error(data.message)
    }
    // 对响应数据做点什么
    return response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export const post = async (url, data)=>{
    try{
        const res = await instance.post(url, data);
        return res.data
    }catch(error) {
        console.log(error);
        return {
          success: false,
          data: null
        }
    };
};
export const get = async (url, params)=>{
    try{
        const res = await instance.get(url, {params});
        return res.data
    }catch(error) {
        console.log(error);
        return {
          success: false,
          data: null
        }
    };
};

export const put = async (url, data)=>{
    try{
        const res = await instance.put(url, data);
        return res.data
    }catch(error) {
        console.log(error);
        return {
          success: false,
          data: null
        }
    };
}

export const deleteAxios = async (url, params)=>{
    try{
        const res = await instance.delete(url, {params});
        return res.data
    }catch(error) {
        console.log(error);
    };
}

export const snatch = async (url, method, data, obj)=>{
    try{
        const res = await instance(obj)({
            method,
            url,
            data
        });
        if(!res.retcode){
            return res
        }else{
        }
    }catch(error) {
        console.log(error);
    };
}
export const upload = async (url, data)=>{
    try{
        const res = await instance.post(url, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return res.data
    }catch(error) {
        console.log(error);
    };
};
export const download = async (url, data)=>{
    try{
        const res = await instance.post(url, data, {
            responseType: 'arraybuffer'
        });
        return res.data
    }catch(error) {
        console.log(error);
    };
};



// WEBPACK FOOTER //
// ./src/apis/http.js